import React from 'react';

const LinksBtn = ({ links }) => {
    return (
        <div className="links-btn">
            {Object.keys(links).map((key, i) => <a key={i} href={links[key]} target="_blank" className="jbutton" rel="noreferrer">{key}</a>)}
        </div>
    );
};

export default LinksBtn;